import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { usePageTitle } from 'routes/Util/Util.hooks';

export const Settings = () => {
  usePageTitle('설정');

  return (
    <Container>
      <Row>
        <Col>
          준비중입니다.
        </Col>
      </Row>
    </Container>
  )
}
